"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.sendRecommendation = sendRecommendation;
exports.resetRecommendation = resetRecommendation;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEND_RECOMMENDATION = "maaporssi/recommend/SEND_RECOMMENDATION";
var SEND_RECOMMENDATION_SUCCESS = "maaporssi/recommend/SEND_RECOMMENDATION_SUCCESS";
var SEND_RECOMMENDATION_FAIL = "maaporssi/recommend/SEND_RECOMMENDATION_FAIL";
var RECOMMENDATION_RESET = "maaporssi/recommend/SEND_RECOMMENDATION_RESET";

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SEND_RECOMMENDATION:
      return (0, _extends3.default)({}, state, {
        sendRecommendationLoading: true
      });
    case SEND_RECOMMENDATION_FAIL:
      return (0, _extends3.default)({}, state, {
        sendRecommendationLoading: false,
        sendRecommendationSuccess: false,
        sendRecommendationError: true
      });
    case SEND_RECOMMENDATION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendRecommendationLoading: false,
        sendRecommendationSuccess: true,
        sendRecommendationError: null
      });
    case RECOMMENDATION_RESET:
      return (0, _extends3.default)({}, state, {
        sendRecommendationLoading: false,
        sendRecommendationSuccess: false,
        sendRecommendationError: null
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.recommend && globalState.recommend.loaded;
}

function sendRecommendation(formData) {
  return {
    types: [SEND_RECOMMENDATION, SEND_RECOMMENDATION_SUCCESS, SEND_RECOMMENDATION_FAIL],
    promise: function promise(client) {
      return client.post("/recommendations", {
        data: formData
      });
    }
  };
}

function resetRecommendation() {
  return {
    type: RECOMMENDATION_RESET
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/recommend.js
 ** module id = 495
 ** module chunks = 0
 **/